import { Component, Input, ChangeDetectorRef, HostBinding } from "@angular/core";
import { BaseControlComponent } from "../base/base-control.component";
import { SelectorService } from "../base/selector.service";
@Component({
  selector: "ssg-button",
  templateUrl: "button.component.html",
  styleUrls: ["button.component.scss"],
})
export class ButtonComponent extends BaseControlComponent<string> {
  @Input() icon: string = "";
  @Input() appearance: string;
  @Input() size: string;
  @Input() buttontype: string;
  @Input() title: string;
  @HostBinding("style.margin-bottom.px") marginbottom: number = 0;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
}
